import { Alert, Button, ConfigProvider, Flex } from 'antd'
import { useInvoicingSettingsQuery } from '../../domain/invoicing/settings/invoicingSettingsQueries'
import { useRainforestMerchantStatusQuery } from '../../domain/invoicing/rainforestQueries'
import { ApplicationStatus } from '../../domain/invoicing/rainforest'
import { useContext } from 'react'
import { AuthenticationContext } from '../../AuthenticationContext'

const SynkedUPPaymentsBanner = () => {
  const { currentUser } =  useContext(AuthenticationContext)
  const invoicingSettingsQuery = useInvoicingSettingsQuery()
  const merchantStatusQuery = useRainforestMerchantStatusQuery()

  const isNonUnitedStates = currentUser?.isTenantConnectedToQuickBooks === true && currentUser?.tenantQuickbooksCompanyCountryCode !== 'US'
  const invoicingSystem = invoicingSettingsQuery.data?.invoicingSystem
  const applicationStatus = merchantStatusQuery.data?.applicationStatus ?? ''
  
  if (isNonUnitedStates) {
    return null
  }

  const statusesToHideBanner = ['PROCESSING', 'IN_REVIEW', 'COMPLETED', 'DECLINED']
  if (invoicingSystem === 'synkedUp' && statusesToHideBanner.includes(applicationStatus)) {
    return null
  }

  return <Banner applicationStatus={applicationStatus} />
}

export default SynkedUPPaymentsBanner

export type BannerProps = {
  applicationStatus: ApplicationStatus
}

export const Banner = ({ applicationStatus }: BannerProps) => {
  if (applicationStatus === 'DECLINED') {
    return null;
  }

  let message = <span>&#10024; <strong>New! SynkedUP Payments:</strong><br/>Send invoices, collect payments, and save customer cards — all inside SynkedUP.</span>
  let buttonText = 'Set up Payments'
  switch (applicationStatus) {
    case 'PROCESSING':
    case 'IN_REVIEW':
      message = <span>&#10024; <strong>Your SynkedUP Payments application is being reviewed:</strong><br/>You’ll be notified as soon as it’s approved.</span>
      buttonText = 'View Invoicing Settings'
      break
    case 'NEEDS_INFORMATION':
      message = <span>&#10024; <strong>Finish your SynkedUP Payments application:</strong><br/>We just need a few more details.</span>
      buttonText = 'Provide Information'
      break
    case 'COMPLETED':
      message = <span>&#10024; <strong>SynkedUP Payments is ready to use:</strong><br/>Turn it on to start sending invoices, collecting payments, and storing cards on file.</span>
      buttonText = 'Enable Payments'
      break
  }

  return (
    <ConfigProvider theme={{ token: { colorInfo: '#FF5C35', colorPrimary: '#FF5C35' } }}>
      <Alert
        type="info"
        style={{ marginBottom: 16 }}
        message={
          <Flex justify="space-between" align="center" gap={16}>
            {message}
            <Button type="primary" onClick={() => window.location.href = '/#!/invoicing-settings'}>
              {buttonText}
            </Button>
          </Flex>
        }
      />
    </ConfigProvider>
  )
}
